"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _style = _interopRequireDefault(require("./style.css"));
var _class = _interopRequireDefault(require("./class.svg"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  name: 'Brown Classroom',
  className: _style["default"].background,
  assets: [_class["default"]],
  imageUrl: _class["default"],
  thumbnail: _thumbnail["default"]
};